import { Link } from "react-router-dom";
import { ChevronLeft, Cpu } from "lucide-react";
import Footer from "../components/landing/Footer";

/**
 * LegalLayout — minimal shell (compact header + footer) used by legal pages.
 */
export default function LegalLayout({ title, updatedAt, children }) {
    return (
        <div className="min-h-screen bg-white">
            <header className="sticky top-0 z-40 bg-white/85 backdrop-blur-xl border-b border-slate-200/70">
                <div className="max-w-4xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
                    <Link
                        to="/"
                        data-testid="legal-brand-logo"
                        className="flex items-center gap-2.5"
                    >
                        <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-[#0B1120] to-[#0f172a]">
                            <Cpu className="w-5 h-5 text-cyan-400" strokeWidth={2.25} />
                            <span className="absolute -bottom-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-teal-400 ring-2 ring-white" />
                        </span>
                        <span className="flex flex-col leading-none">
                            <span className="font-display font-bold text-[19px] text-slate-900 tracking-tight">
                                TecSuite
                            </span>
                            <span className="text-[10.5px] uppercase tracking-[0.18em] text-slate-500 font-medium mt-0.5">
                                by Tecnologie
                            </span>
                        </span>
                    </Link>
                    <Link
                        to="/"
                        data-testid="legal-back-home"
                        className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-700 hover:text-slate-900"
                    >
                        <ChevronLeft className="w-4 h-4" /> Torna al sito
                    </Link>
                </div>
            </header>

            <main className="max-w-4xl mx-auto px-6 lg:px-8 py-16 sm:py-20 lg:py-24">
                <div>
                    <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-cyan-700">
                        <span className="h-px w-8 bg-cyan-500" />
                        Informativa legale
                    </span>
                    <h1
                        data-testid="legal-title"
                        className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900"
                    >
                        {title}
                    </h1>
                    <p className="mt-3 text-sm text-slate-500">
                        Ultimo aggiornamento: <time dateTime={updatedAt}>{updatedAt}</time>
                    </p>
                </div>

                <article
                    data-testid="legal-content"
                    className="mt-10 prose prose-slate max-w-none prose-headings:font-display prose-headings:tracking-tight prose-h2:text-2xl prose-h2:mt-12 prose-h2:mb-4 prose-h3:text-lg prose-h3:mt-8 prose-h3:mb-2 prose-p:leading-relaxed prose-p:text-slate-700 prose-a:text-cyan-700 prose-a:font-semibold prose-a:no-underline hover:prose-a:underline prose-li:text-slate-700 prose-strong:text-slate-900"
                >
                    {children}
                </article>

                <div className="mt-16 pt-8 border-t border-slate-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                    <p className="text-sm text-slate-500">
                        Per domande scrivi a{" "}
                        <a
                            href="mailto:info@tecsuite.it"
                            className="font-semibold text-cyan-700 hover:underline"
                        >
                            info@tecsuite.it
                        </a>
                    </p>
                    <Link
                        to="/"
                        className="inline-flex items-center gap-1.5 rounded-full bg-slate-900 hover:bg-slate-800 text-white text-sm font-semibold px-5 py-2.5 transition"
                    >
                        <ChevronLeft className="w-4 h-4" /> Torna alla home
                    </Link>
                </div>
            </main>

            <Footer />
        </div>
    );
}
